import { useContext, useEffect, useState } from 'react';
import { SourceContext } from '../../../utils/sourceContext';
import { getCachedState, initUserState } from '../../../utils/stateContext';
import Header from '../../.shared/header/header';
import Footer from '../../.shared/footer/footer';
import LegitScriptBanner from '../../.shared/LegitScriptBanner/LegitScriptBanner';
import CEOHero from './CEOHero';
import CEOVideoSection from './CEOVideoSection';
import CEOStory from './CEOStory';
import PatientStories from '../../.shared/PatientStories/PatientStories';
import CEOFAQ from './CEOFAQ';

const CEO_VIDEO_URL = 'https://www.youtube.com/embed/e-o5rwuPTkc?rel=0&modestbranding=1';

function CEOLanding() {
    const { source, safeSource, switchAndSave } = useContext(SourceContext);
    const [userState, setUserState] = useState(getCachedState);
    const NON_SWITCH_AND_SAVE_STATES = (() => { try { return JSON.parse(process.env.REACT_APP_NON_SWITCH_AND_SAVE_STATES || '[]'); } catch { return []; } })();
    const stateBlocked = NON_SWITCH_AND_SAVE_STATES.length > 0 && NON_SWITCH_AND_SAVE_STATES.includes(userState);

    useEffect(() => {
        if (NON_SWITCH_AND_SAVE_STATES.length > 0) {
            initUserState().then(() => setUserState(getCachedState()));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!NON_SWITCH_AND_SAVE_STATES || NON_SWITCH_AND_SAVE_STATES.length === 0) {
        return (
            <>
                <Header hideNavigation={source !== 'tb2'} />
                <CEOHero safeSource={safeSource} switchAndSaveSource={switchAndSave} />
                <CEOVideoSection videoUrl={CEO_VIDEO_URL} />
                <CEOStory />
                <PatientStories />
                <CEOFAQ />
                <LegitScriptBanner />
                <Footer />
            </>
        );
    }

    if (userState === null) return null;

    return (
        <>
            <Header hideNavigation={source !== 'tb2'} />
            <CEOHero safeSource={safeSource} switchAndSaveSource={switchAndSave && !stateBlocked} />
            <CEOVideoSection videoUrl={CEO_VIDEO_URL} />
            <CEOStory />
            <PatientStories />
            <CEOFAQ />
            <LegitScriptBanner />
            <Footer />
        </>
    );
}

export default CEOLanding;
